import { SimpleEventDispatcher } from 'ste-simple-events';

export const supplierComplianceDocumentEvents = {
  changed: new SimpleEventDispatcher<number>(),
};
